import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimeslotsConstants } from '../../modules/map/constants/timeslots.constants';

@Pipe({ name: 'timeslotsAvailability' })
export class TimeslotsAvailabilityPipe implements PipeTransform {

  constructor(public translateService: TranslateService) {
  }

  public transform(value: number) {
    let label = "";
    if (value === TimeslotsConstants.UNAVAILABLE_TIMESLOT) {
      label = "TIMESLOT_LABELS.UNAVAILABLE";
    } else if (value === TimeslotsConstants.AVAILABLE_TODAY) {
      label = "TIMESLOT_LABELS.AVAILABLE_TODAY";
    } else if (value === TimeslotsConstants.AVAILABLE_TOMORROW) {
      label = "TIMESLOT_LABELS.AVAILABLE_TOMORROW";
    } else if (value === TimeslotsConstants.AVAILABLE_DAY_AFTER_TOMORROW) {
      label = "TIMESLOT_LABELS.AVAILABLE_DAY_AFTER_TOMORROW";
    } else if (value > TimeslotsConstants.AVAILABLE_DAY_AFTER_TOMORROW) {
      return "+" + value;
    }
    this.translateService.get(label).subscribe(value => {
      label = value;
    });
    return label;
  }
}
